<template>
  <base-section
    background="gradient"
    spacing="large"
  >
    <div class="cta-content">
      <h2 class="cta-title">今すぐ始める、プロフェッショナルなサロンワーク</h2>
      <p class="cta-description">
        初期費用0円で、今すぐあなたのサロンをスタートできます。<br>
        まずは無料見学で、Kaon Rの魅力を体感してください。
      </p>
      <div class="cta-actions">
        <base-button
          variant="secondary"
          size="lg"
          to="/reserve"
          icon="fas fa-calendar-check"
        >
          ご予約・見学受付をする
        </base-button>
        <base-button
          variant="ghost"
          size="lg"
          to="/contact"
          icon="fas fa-envelope"
        >
          お問い合わせ
        </base-button>
      </div>
    </div>
  </base-section>
</template>

<script>
import BaseSection from '@/components/common/BaseSection.vue';
import BaseButton from '@/components/common/BaseButton.vue';

export default {
  name: 'CTASection',
  components: {
    BaseSection,
    BaseButton
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
@import '@/styles/mixins.scss';

.cta-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.cta-title {
  font-size: $font-size-3xl;
  font-weight: 700;
  color: $white;
  margin-bottom: $spacing-lg;
  
  @include media-breakpoint-down(md) {
    font-size: $font-size-2xl;
  }
  
  &::after {
    display: none; // BaseSection のデフォルトスタイルを上書き
  }
}

.cta-description {
  font-size: $font-size-lg;
  color: rgba($white, 0.9);
  line-height: 1.8;
  margin-bottom: $spacing-2xl;
  
  @include media-breakpoint-down(md) {
    font-size: $font-size-md;
  }
}

.cta-actions {
  display: flex;
  gap: $spacing-md;
  justify-content: center;
  flex-wrap: wrap;
  
  @include media-breakpoint-down(sm) {
    flex-direction: column;
    align-items: center;
    
    .base-button {
      width: 100%;
      max-width: 300px;
    }
  }
  
  .base-button--ghost {
    color: $white;
    border-color: rgba($white, 0.3);
    
    &:hover {
      background-color: rgba($white, 0.1);
      border-color: rgba($white, 0.5);
      color: $white;
    }
  }
}</style>